import React, { useState } from 'react';
import { Box, Text } from '@wix/design-system';
export const FaqQuestion = ({ question }) => {
    const [isHovering, setIsHovering] = useState(false);
    return (React.createElement(Box, { flex: 1 },
        React.createElement("div", { onMouseEnter: () => setIsHovering(true), onMouseLeave: () => setIsHovering(false) },
            React.createElement(Text, { weight: "bold", size: "medium", tagName: "h2", dataHook: "faq-question", skin: isHovering ? 'primary' : 'standard' }, question))));
};
//# sourceMappingURL=FaqQuestion.js.map